import { API_BASE_URL } from "../../config"
import request from "../../utilities/request"

const removeHolderFromCategory = (category, holder) => request.put(`${API_BASE_URL}/blockchain/category/${category}/registered-users/${holder}/remove`)

export default removeHolderFromCategory